import { useState, useContext } from "react";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";

import classes from "./Share.module.css";
import MUIIconButton from "../../../Component/UI/MUIIconButton/MUIIconButton";
import { DiscoveryContext } from "../discovery-context";
import { toast } from "react-toastify";
import { AuthContext } from "../../../context/auth-context";
import { ENTITY_LABELS } from "../../../utils/labelMapping";

export default function Share() {
  const discoveryCtx = useContext(DiscoveryContext);
  const [isCopied, setIsCopied] = useState(false);
  const { user } = useContext(AuthContext);
  const docId = discoveryCtx.state.transactionId;
  const type = discoveryCtx.type;
  const documentPath = `${window.location.origin}${window.location.pathname}?type=${type}&id=${docId}&customer_id=${user?.user_role?.user_id}`;
  async function handleCopy() {
    await navigator.clipboard.writeText(documentPath);
    setIsCopied(true);
    toast.success("Share link is copied.");
    setTimeout(() => {
      setIsCopied(false);
    }, 4000);
  }

  return (
    <div>
      <div className={classes.label}>{discoveryCtx.entity} {ENTITY_LABELS.brand} Audit</div>
      <div className={classes.copy_container}>
        <span className={classes.path}>{documentPath}</span>
        <MUIIconButton onClick={handleCopy} tooltip="Click to copy">
          {isCopied ? (
            <DoneOutlinedIcon color="success" />
          ) : (
            <ContentCopyOutlinedIcon />
          )}
        </MUIIconButton>
      </div>
    </div>
  );
}
